export default {
      id: "chat-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#chat",
      toString: function () {
        return this.url;
      }
    }